import type { ApolloCache } from "@apollo/client/cache"

import { ProjectParentTypename } from "shared/types/Project"

import { getProjectChildren } from "./getProjectChildren"
import { sortProjectChildrenAndUpdateIndex } from "./sortProjectChildren"
import { updateProjectChildren } from "./updateProjectChildren"

export function restoreProjectChildrenSorting(
  parentID: string,
  parentType: ProjectParentTypename,
  cache: ApolloCache<object>
) {
  const children = sortProjectChildrenAndUpdateIndex(
    getProjectChildren(parentID, parentType, cache) || []
  )

  updateProjectChildren({
    parentID,
    parentType,
    children,
    cache
  })
}
